import a from 'moment'

export default moment => (date, format = 'DD/MM/YYYY ') => {
  if (!date) return '-'
  try {
    return moment(date)
      .utc()
      .format(format)
  } catch (e) {
    return date
  }
}
